import PropTypes from 'prop-types';
import React from 'react';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import { Dialog, IconButton, Switch } from 'react-toolbox';
import { connect } from 'react-redux';
import { upperFirst, isNull, isUndefined } from 'lodash';
import InitialInfo from './initialInfo';
import InstallerPreWalkthrough from './pre/installerPreWalkthrough';
import InstallerPostWalkthrough from './post/installerPostWalkthrough';
import CustomerPreWalkthrough from './pre/customerPreWalkthrough';
import CustomerPostWalkthrough from './post/customerPostWalkthrough';
import SurplusMaterial from '../SignCocModal/surplus_material';
import FinalChecks from './finalChecks';
import InstallerSignature from './installerSignature';
import CustomerSignature from './customerSignature';
import S from 'modal.scss';
import Loading from 'components/Loading';
import styles from 'styles/input.scss';
import { clearValidation, walkthroughCreate } from 'actionCreators';
import PhaseType from 'types/phase';

class WalkthroughModal extends Resetter(Validator(React.Component)) {
  static DEFAULT_STATE = {
    installerInitials: '',
    installerName: '',
    installerSignature: '',

    installerParkedInStreet: false,
    installerDrivewayPermission: false,
    installerProtectFromOil: false,
    installerCarpetSeamPlacement: false,
    installerCarpetSeamVisibility: false,
    installerHardSurfaceMoistureReadings: false,
    installerActualReading: '',

    installerCarpetAllSeamsSealed: false,
    installerCarpetPowerStretched: false,
    installerCarpetVacuumed: false,
    installerCarpetCleanedUp: false,

    customerInitials: '',
    customerName: '',
    customerSignature: '',
    customerApprovedSignature: false,

    customerMaterialsAndColor: false,
    customerClimateControl: false,
    customerCarpetSeamPlacement: false,
    customerCarpetRoomsToBeInstalled: false,
    customerCarpetScuffs: false,
    customerHardSurfaceRoomsAndMoisture: false,
    customerHardSurfaceMoistureBarrier: false,

    customerCarpetSeamAndExcess: false,
    customerHardSurfaceTransition: false,
    customerHardSurfaceMolding: false,
    customerHardSurfaceMaterial: false,
    customerHardSurfaceFloorHeight: false,
    customerHardSurfaceDoorCuts: false,
    customerHardSurfaceWaste: false,

    hardSurfaceHomeTemp: '',
    hardSurfaceAllMaterialsOnsite: '',
    hardSurfaceMaterialDamage: '',
    hardSurfaceMaterialDamageDetails: '',
    siteDamageInstaller: false,
    siteDamageCustomer: false,
    siteDamageDetails: '',
    sixSquareFeetRemoved: '',
    homeOlderThan1978: '',
    leadResponseReason: '',
    leadPracticesReq: false,

    excessMaterials: 'NO_EXCESS_MATERIALS',

    errors: {},
    tab: 1,
    isSpanish: false,
    step: '',
  };

  static VALIDATIONS = {
    installerInitials: true,
    installerName: true,
    installerSignature: true,
  }

  updateFormData = (walkthroughData) => {
    const { phase, phase: { id } } = this.props;
    this.setState(walkthroughData, () => {
      if (walkthroughData.tab === 8) {
        const { installerInitials, customerInitials, installerParkedInStreet,
          installerDrivewayPermission, installerProtectFromOil, installerCarpetSeamPlacement,
          installerCarpetSeamVisibility, installerHardSurfaceMoistureReadings,
          installerActualReading, installerCarpetAllSeamsSealed,
          installerCarpetVacuumed, installerCarpetCleanedUp, customerMaterialsAndColor,
          customerClimateControl, customerCarpetSeamPlacement,
          customerCarpetScuffs, customerHardSurfaceRoomsAndMoisture,
          customerHardSurfaceMoistureBarrier, customerCarpetSeamAndExcess,
          customerHardSurfaceTransition, customerHardSurfaceMaterial,
          customerHardSurfaceFloorHeight, customerHardSurfaceDoorCuts,
          customerHardSurfaceWaste, hardSurfaceHomeTemp,
          hardSurfaceAllMaterialsOnsite, hardSurfaceMaterialDamage,
          hardSurfaceMaterialDamageDetails, siteDamageInstaller, siteDamageCustomer,
          siteDamageDetails, installerName, installerSignature, customerName,
          customerSignature, installerCarpetPowerStretched, customerCarpetRoomsToBeInstalled,
          customerHardSurfaceMolding, customerApprovedSignature, leadResponseReason,
          leadPracticesReq, excessMaterials, step,
        } = this.state;

        this.props.walkthroughCreate({
          installer_initials: installerInitials,
          installer_name: installerName,
          installer_signature: installerSignature,

          installer_parked_in_street: installerParkedInStreet,
          installer_driveway_permission: installerDrivewayPermission,
          installer_protect_from_oil: installerProtectFromOil,
          installer_carpet_seam_placement: installerCarpetSeamPlacement,
          installer_carpet_seam_visibility: installerCarpetSeamVisibility,
          installer_hard_surface_moisture_readings: installerHardSurfaceMoistureReadings,
          installer_actual_reading: installerActualReading,

          installer_carpet_all_seams_sealed: installerCarpetAllSeamsSealed,
          installer_carpet_power_stretched: installerCarpetPowerStretched,
          installer_carpet_vacuumed: installerCarpetVacuumed,
          installer_carpet_cleaned_up: installerCarpetCleanedUp,

          customer_initials: customerInitials,
          customer_name: customerName,
          customer_signature: customerSignature,
          customer_approved_signature: customerApprovedSignature,

          customer_materials_and_color: customerMaterialsAndColor,
          customer_climate_control: customerClimateControl,
          customer_carpet_seam_placement: customerCarpetSeamPlacement,
          customer_carpet_rooms_to_be_installed: customerCarpetRoomsToBeInstalled,
          customer_carpet_scuffs: customerCarpetScuffs,
          customer_hard_surface_rooms_and_moisture: customerHardSurfaceRoomsAndMoisture,
          customer_hard_surface_moisture_barrier: customerHardSurfaceMoistureBarrier,

          customer_carpet_seam_and_excess: customerCarpetSeamAndExcess,
          customer_hard_surface_transition: customerHardSurfaceTransition,
          customer_hard_surface_molding: customerHardSurfaceMolding,
          customer_hard_surface_material: customerHardSurfaceMaterial,
          customer_hard_surface_floor_height: customerHardSurfaceFloorHeight,
          customer_hard_surface_door_cuts: customerHardSurfaceDoorCuts,
          customer_hard_surface_waste: customerHardSurfaceWaste,

          hard_surface_home_temp: hardSurfaceHomeTemp,
          hard_surface_all_materials_onsite: hardSurfaceAllMaterialsOnsite,
          hard_surface_material_damage: hardSurfaceMaterialDamage,
          hard_surface_material_damage_details: hardSurfaceMaterialDamageDetails,
          site_damage_details: siteDamageDetails,
          site_damage_installer: siteDamageInstaller,
          site_damage_customer: siteDamageCustomer,

          lead_response_reason: leadResponseReason,
          lead_practices_required: leadPracticesReq,

          excess_materials: excessMaterials,

          surface_type: this.determineSurfaceType(phase),
          step,
          phase_id: id,
          is_walkthrough: true,
        }).then(() => {
          this.handleClose();
        }).catch(() => { });
      }
    });
  }

  handleLanguageChange = val => this.setState({ isSpanish: val });

  handleClose() {
    super.handleClose();
    this.props.clearValidation();
    document.location.reload();
  }

  determineSurfaceType = (phase) => {
    if (isUndefined(phase.surface_type) || isNull(phase.surface_type)) return '';
    return phase.surface_type.name.toLowerCase() === 'carpet' ?
      'carpet' : 'hard_surface';
  }

  determineSurfaceTypeTitle = (surfaceType) => {
    if (!surfaceType) return ' ';
    return surfaceType.toLowerCase() === 'carpet' ?
      ' Carpet ' : ' Hard Surface ';
  };

  showTab = () => {
    const { phase, showLeadQuestion } = this.props;
    const { step, isSpanish, installerInitials, customerInitials, installerParkedInStreet,
      installerDrivewayPermission, installerProtectFromOil, installerCarpetSeamPlacement,
      installerCarpetSeamVisibility, installerHardSurfaceMoistureReadings,
      installerActualReading, installerCarpetAllSeamsSealed, installerCarpetPowerStretched,
      installerCarpetVacuumed, installerCarpetCleanedUp, customerMaterialsAndColor,
      customerClimateControl, customerCarpetSeamPlacement, customerCarpetRoomsToBeInstalled,
      customerCarpetScuffs, customerHardSurfaceRoomsAndMoisture,
      customerHardSurfaceMoistureBarrier, customerCarpetSeamAndExcess,
      customerHardSurfaceTransition, customerHardSurfaceMolding,
      customerHardSurfaceMaterial, customerHardSurfaceFloorHeight,
      customerHardSurfaceDoorCuts, customerHardSurfaceWaste, hardSurfaceHomeTemp,
      hardSurfaceAllMaterialsOnsite, hardSurfaceMaterialDamage,
      hardSurfaceMaterialDamageDetails, siteDamageInstaller, siteDamageCustomer,
      siteDamageDetails, installerName, installerSignature, customerName,
      customerSignature, sixSquareFeetRemoved, homeOlderThan1978, tab,
      leadResponseReason, leadPracticesReq, excessMaterials } = this.state;
    const surfaceType = this.determineSurfaceType(phase);
    if (!surfaceType) return this.renderNoSurfaceTypeMessage();
    switch (tab) {
      case 1:
        return (<InitialInfo
          isSpanish={isSpanish}
          phase={phase}
          updateFormData={this.updateFormData}
          installerInitials={installerInitials}
          customerName={customerName}
          customerInitials={customerInitials}
          installerName={installerName}
          surfaceType={surfaceType}
          step={step}
        />);
      case 2:
        if (step === 'pre') {
          return (<InstallerPreWalkthrough
            isSpanish={isSpanish}
            phase={phase}
            updateFormData={this.updateFormData}
            surfaceType={surfaceType}
            installerParkedInStreet={installerParkedInStreet}
            installerDrivewayPermission={installerDrivewayPermission}
            installerProtectFromOil={installerProtectFromOil}
            installerCarpetSeamPlacement={installerCarpetSeamPlacement}
            installerCarpetSeamVisibility={installerCarpetSeamVisibility}
            installerHardSurfaceMoistureReadings={installerHardSurfaceMoistureReadings}
            installerActualReading={installerActualReading}
          />);
        }
        return (<InstallerPostWalkthrough
          isSpanish={isSpanish}
          phase={phase}
          updateFormData={this.updateFormData}
          installerCarpetAllSeamsSealed={installerCarpetAllSeamsSealed}
          installerCarpetPowerStretched={installerCarpetPowerStretched}
          installerCarpetVacuumed={installerCarpetVacuumed}
          installerCarpetCleanedUp={installerCarpetCleanedUp}
        />);
      case 3:
        if (step === 'pre') {
          return (<CustomerPreWalkthrough
            isSpanish={isSpanish}
            phase={phase}
            updateFormData={this.updateFormData}
            surfaceType={surfaceType}
            customerMaterialsAndColor={customerMaterialsAndColor}
            customerClimateControl={customerClimateControl}
            customerCarpetSeamPlacement={customerCarpetSeamPlacement}
            customerCarpetRoomsToBeInstalled={customerCarpetRoomsToBeInstalled}
            customerCarpetScuffs={customerCarpetScuffs}
            customerHardSurfaceRoomsAndMoisture={customerHardSurfaceRoomsAndMoisture}
            customerHardSurfaceMoistureBarrier={customerHardSurfaceMoistureBarrier}
          />);
        }
        return (<CustomerPostWalkthrough
          isSpanish={isSpanish}
          phase={phase}
          updateFormData={this.updateFormData}
          surfaceType={surfaceType}
          customerCarpetSeamAndExcess={customerCarpetSeamAndExcess}
          customerHardSurfaceTransition={customerHardSurfaceTransition}
          customerHardSurfaceMolding={customerHardSurfaceMolding}
          customerHardSurfaceMaterial={customerHardSurfaceMaterial}
          customerHardSurfaceFloorHeight={customerHardSurfaceFloorHeight}
          customerHardSurfaceDoorCuts={customerHardSurfaceDoorCuts}
          customerHardSurfaceWaste={customerHardSurfaceWaste}
        />);
      case 4:
        return (<SurplusMaterial
          isSpanish={isSpanish}
          phase={phase}
          updateFormData={this.updateFormData}
          excessMaterials={excessMaterials}
        />);
      case 5:
        return (<FinalChecks
          isSpanish={isSpanish}
          phase={phase}
          updateFormData={this.updateFormData}
          step={step}
          showLeadQuestion={showLeadQuestion}
          sixSquareFeetRemoved={sixSquareFeetRemoved}
          homeOlderThan1978={homeOlderThan1978}
          surfaceType={surfaceType}
          hardSurfaceHomeTemp={hardSurfaceHomeTemp}
          hardSurfaceAllMaterialsOnsite={hardSurfaceAllMaterialsOnsite}
          hardSurfaceMaterialDamage={hardSurfaceMaterialDamage}
          hardSurfaceMaterialDamageDetails={hardSurfaceMaterialDamageDetails}
          siteDamageInstaller={siteDamageInstaller}
          siteDamageCustomer={siteDamageCustomer}
          siteDamageDetails={siteDamageDetails}
          leadResponseReason={leadResponseReason}
          leadPracticesReq={leadPracticesReq}
        />);
      case 6:
        return (<InstallerSignature
          isSpanish={isSpanish}
          phase={phase}
          step={step}
          updateFormData={this.updateFormData}
          installerSignature={installerSignature}
        />);
      case 7:
        return (<CustomerSignature
          isSpanish={isSpanish}
          phase={phase}
          updateFormData={this.updateFormData}
          customerSignature={customerSignature}
        />);
      default:
        return (<Loading />);
    }
  }

  renderNoSurfaceTypeMessage = () =>
    <div className={S.emptyModal}>
      This phase requires a surface type to complete a walkthrough
    </div>

  render = () => {
    const { active, errors: serverErrors, phase } = this.props;
    const { isSpanish, step } = this.state;
    const surfaceType = this.determineSurfaceType(phase);
    const surfaceTypeTitle = this.determineSurfaceTypeTitle(surfaceType);

    return (<Dialog
      active={active} className={S.modal} type="fullscreen"
      onEscKeyDown={this.handleClose} onOverlayClick={this.handleClose}
    >
      <div className={styles.errored}>
        {Object.keys(serverErrors).length > 0 &&
          <span className={styles.error}>This action could not be completed.</span>}
      </div>
      <IconButton icon="close" className={S.close} onClick={this.handleClose} />
      <h5>
        Sign{surfaceTypeTitle}{step ? `${upperFirst(step)}-Walkthrough ` : 'Walkthrough '}Form
      </h5>
      <Switch
        checked={isSpanish}
        label="¿En español?"
        onChange={this.handleLanguageChange}
      />
      {this.showTab()}
    </Dialog>);
  }
}

WalkthroughModal.propTypes = {
  active: PropTypes.bool.isRequired,
  clearValidation: PropTypes.func.isRequired,
  walkthroughCreate: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  phase: PhaseType.isRequired,
  showLeadQuestion: PropTypes.bool,
  errors: PropTypes.shape({
    signature: PropTypes.arrayOf(PropTypes.string),
    name: PropTypes.arrayOf(PropTypes.string),
  }),
};

WalkthroughModal.defaultProps = {
  active: false,
  showLeadQuestion: false,
};

export default connect(state => ({ errors: state.walkthroughs.uploadError }), {
  clearValidation,
  walkthroughCreate,
})(WalkthroughModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/tasks/components/WalkthroughModal/index.jsx